import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: { items: [] },
  reducers: {
    setNotifications: (state, action) => {
      state.items = Array.isArray(action.payload) ? action.payload : [];
    },
    prependNotification: (state, action) => {
      const notification = action.payload;
      if (!notification?.id) return;
      if (!state.items.some((item) => String(item?.id) === String(notification.id))) {
        state.items.unshift(notification);
      }
    },
    markNotificationRead: (state, action) => {
      const id = action.payload;
      state.items.forEach((item) => {
        if (String(item?.id) === String(id)) item.status = true;
      });
    },
    markAllNotificationsRead: (state) => {
      state.items.forEach((item) => { item.status = true; });
    },
    clearNotifications: (state) => { state.items = []; },
  },
});

export const {
  setNotifications,
  prependNotification,
  markNotificationRead,
  markAllNotificationsRead,
  clearNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;
